import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import StatisticsItemComponent from './Statistics-item.component';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import TvIcon from '@mui/icons-material/Tv';
import Battery2BarIcon from '@mui/icons-material/Battery2Bar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import PersonIcon from '@mui/icons-material/Person';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    login,
    groupsNumber,
    devicesNumber,
    lowChargeDevicesNumber,
    longTimeNoContactDevicesNumber,
    noTelemetryDevicesNumber,
    onClose,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <ModalComponent
            className="statistics"
            title="aboutAccount"
            lang={lang}
            onBtnKeyDown={onClose}
            onClose={onClose}
        >
            <List className="statistics__list">
                <StatisticsItemComponent
                    type="login"
                    title={getWord('login')}
                    value={login}
                    icon={PersonIcon}
                />
                <StatisticsItemComponent
                    title={getWord('groupsNumber')}
                    value={groupsNumber}
                    icon={DevicesOtherIcon}
                />
                <StatisticsItemComponent
                    title={getWord('devicesNumber')}
                    value={devicesNumber}
                    icon={TvIcon}
                />
                <StatisticsItemComponent
                    title={getWord('devicesNumberWithLowCharge')}
                    value={lowChargeDevicesNumber}
                    icon={Battery2BarIcon}
                />
                <StatisticsItemComponent
                    title={getWord('devicesNumberLongTimeNoContact')}
                    value={longTimeNoContactDevicesNumber}
                    icon={AccessTimeIcon}
                />
                <StatisticsItemComponent
                    title={getWord('devicesNumberNoTelemetry')}
                    value={noTelemetryDevicesNumber}
                    icon={DeviceUnknownIcon}
                />
            </List>
            <Box className="statistics__btn-bar">
                <ButtonComponent label="close" lang={lang} onClick={onClose} />
            </Box>
        </ModalComponent>
    );
};

const StatisticsComponent = React.memo(Component);

export default StatisticsComponent;
